import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

type JEStatusUpdateModalProps = {
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  isLoading?: boolean;
};

export default function JEStatusUpdateModal({
  title,
  description,
  confirmLabel,
  onConfirm,
  isLoading = false,
}: JEStatusUpdateModalProps) {
  return (
    <>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Modal.Close />
      </Modal.Header>
      <Modal.Body>
        <p className="t-text-body-lg t-text-text-60">{description}</p>
      </Modal.Body>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button>Cancel</Button>
        </Modal.RawClose>
        <Button
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
          customType="primary"
        >
          {confirmLabel}
        </Button>
      </Modal.FooterButtonGroup>
    </>
  );
}
